import { render, staticRenderFns } from "./013_Credits.vue?vue&type=template&id=88bbc028&"
import script from "./013_Credits.vue?vue&type=script&lang=js&"
export * from "./013_Credits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports